import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AuthGuard } from './shared/auth/auth-guard';
import { AccountInformationComponent } from './shared/components/account-information/account-information.component';
import { UserAdministrationComponent } from '@shared/components/user-administration/user-administration.component';
import { PayOnlineCancelComponent } from './components/payments/components/pay-online/cancel/pay-online-cancel.component';
import { PayOnlineDuplicateComponent } from './components/payments/components/pay-online/duplicate/pay-online-duplicate.component';
import { PayOnlineFailureComponent } from './components/payments/components/pay-online/failure/pay-online-failure.component';
import { PayOnlineComponent } from './components/payments/components/pay-online/pay-online.component';
import { PayOnlineSuccessComponent } from './components/payments/components/pay-online/success/pay-online-success.component';
import { PaymentsComponent } from './components/payments/components/payments/payments.component';
import { LicensedAgenciesComponent } from './components/license/in-home-care/licensed-agencies/licensed-agencies.component';
import { ComplaintComponent } from './components/reusable/compliance/complaint/complaint.component';
import { HemoTechPublicListComponent } from './components/license/hemo-tech/hemo-tech-public-list/hemo-tech-public-list.component';
import { AccessibilityNoticeComponent } from './components/accessibility/accessibility-notice/accessibility-notice.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [ AuthGuard ]
      },
      {
        path: 'accessibility-notice',
        component: AccessibilityNoticeComponent
      },
      {
        path: 'account-information',
        component: AccountInformationComponent,
        canActivate: [ AuthGuard ]
      },
      {
        path: 'welcome',
        component: WelcomeComponent },
      {
        path: 'sessions',
        loadChildren: () => import('./shared/components/sessions/sessions.module').then(m => m.SessionsModule)
      },
      {
        path: "user-management",
        component: UserAdministrationComponent,
        canActivate: [ AuthGuard ]
      },
      {
        path: "license",
        loadChildren: () => import('./components/license/license.module').then(m => m.LicenseModule)
      },
      { path: 'payments',
        canActivate: [ AuthGuard ],
        component: PaymentsComponent
      },

      { path: 'pay-online/:id',
        canActivate: [ AuthGuard ],
        component: PayOnlineComponent
      },
      { path: 'payment/cancel',
        canActivate: [ AuthGuard ],
        component: PayOnlineCancelComponent
      },
      { path: 'payment/failure',
        canActivate: [ AuthGuard ],
        component: PayOnlineFailureComponent
      },
      { path: 'payment/duplicate',
        canActivate: [ AuthGuard ],
        component: PayOnlineDuplicateComponent
      },
      { path: 'payment/success',
        canActivate: [ AuthGuard ],
        component: PayOnlineSuccessComponent
      }
    ]
  },
  {
    path: 'licensed-ihc-agencies',
    component: LicensedAgenciesComponent
  },
  {
    path: 'hemo-tech-public-list',
    component: HemoTechPublicListComponent
  },
  {
    path: 'complaints',
    component: ComplaintComponent
  },
  {
    path: 'complaints/:complaintId/:clientId',
    component: ComplaintComponent
  },
  { path: '**', redirectTo: 'training' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: environment.useHash,
    initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled"
})
  ],
  exports: [RouterModule],
  declarations: [
  ]
})
export class RoutesRoutingModule { }
